import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { NewsItem } from '../../models/news-item';
import { NewsService } from '../../services/news.service';

@Component({
  selector: 'app-news-page',
  standalone: true,
  imports: [RouterLink, DatePipe],
  templateUrl: './news-page.component.html',
  styleUrl: './news-page.component.scss'
})
export class NewsPageComponent {
  private readonly news = inject(NewsService);

  readonly items = rxResource<NewsItem[], unknown>({
    stream: () => this.news.list(),
    defaultValue: []
  });
}
